module.exports = __webpack_public_path__ + "img/l_ht.2e19b6a4.png";